import React from "react";
import styled from "styled-components";
import Label from "../label";

const scenarioA = ({ siteGroup }) => {
  const { eventualSiteEnrollmentRate, eventualSiteEnrollmentDays } = siteGroup;

  return (
    <Container>
      <Content>
        <Label value={eventualSiteEnrollmentDays}>
          Number of Days to Site Fatigue
        </Label>
        <Label value={eventualSiteEnrollmentRate}>
          Reduced Enrollment Rate (p/s/m)
        </Label>
      </Content>
    </Container>
  );
};

export default scenarioA;

const Container = styled.div``;

const Content = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  margin-top: 1em;
`;
